export default __webpack_public_path__ + "static/img-5-4d3d759c82bf9d82419f2f99338767f8.png";